export default __webpack_public_path__ + "static/adam-9cf52b6e8ac2db581c49ca9cf1f2e658.woff";